import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { DuplicateExecutionData } from '../../types';
import { DUPLICATE_EXECUTION_MESSAGE } from '../../utils/api-errors';

function executedLabel(executedAt: string): string {
  const date = new Date(executedAt);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('fa-IR', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function DuplicateExecutionNotice({
  duplicate,
  onViewResult,
  className = '',
}: {
  duplicate?: DuplicateExecutionData | null;
  onViewResult?: () => void;
  className?: string;
}) {
  const meta = duplicate
    ? [duplicate.modelName, executedLabel(duplicate.executedAt)].filter(Boolean)
    : [];
  const shortId = duplicate ? `${duplicate.existingRequestId.slice(0, 8)}…` : '';

  return (
    <Alert variant="warning" className={`d-flex align-items-center gap-2 mb-0 py-2 fs--1 ${className}`}>
      <FontAwesomeIcon icon="exclamation-triangle" className="flex-shrink-0" />
      <div className="flex-grow-1 min-w-0">
        <p className="mb-0 text-justify">{DUPLICATE_EXECUTION_MESSAGE}</p>
        {meta.length > 0 && (
          <p className="mb-0 mt-1">
            {meta.join(' · ')}
            {shortId && (
              <span className="font-monospace" title={duplicate?.existingRequestId}>
                {` · ${shortId}`}
              </span>
            )}
          </p>
        )}
      </div>
      {duplicate && onViewResult && (
        <Button
          type="button"
          variant="link"
          size="sm"
          className="p-0 flex-shrink-0 text-nowrap text-decoration-none"
          onClick={onViewResult}
        >
          مشاهده نتیجه
        </Button>
      )}
    </Alert>
  );
}

/** Danger alert, except the daily-duplicate message which uses the compact notice. */
export function ExecutionAlert({
  message,
  className = 'mb-3',
}: {
  message: string;
  className?: string;
}) {
  if (message === DUPLICATE_EXECUTION_MESSAGE) {
    const spacing = className.includes('mb-0')
      ? 'mb-0'
      : className.includes('mb-4')
        ? 'mb-4'
        : 'mb-3';
    return <DuplicateExecutionNotice className={spacing} />;
  }

  return (
    <Alert variant="danger" className={className}>
      {message}
    </Alert>
  );
}
